import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Header } from '../header/Header';
import { Content } from '../content/Content';
import { Keyboard } from '../../components/keyboard/Keyboard';
import useKeyboard from '../../contexts/keyboard/KeyboardContext';
import { setSelectedPage } from '../../store/slices/app/appSlice';
import { RootState } from '../../store/store';
import useLanguage from '../../contexts/language/LanguageContext';
import { Translation } from '../../contexts/language/translationType';


let selectedPage = ''
let selectedLanguage: { translations: Translation } | null = null

export const Main = (): React.ReactElement => {
  const keyboardContext = useKeyboard()
  const dispatch = useDispatch()

  const language = useLanguage()
  const appState = useSelector((state: RootState) => state.app)
  selectedPage = appState.selectedPage
  selectedLanguage = language

  useEffect(() => {
    history.pushState(null, '', null)
    addEventListener('popstate', () => {
      if (selectedPage === '/') {
        return true
      }
      const leavePage = confirm(selectedLanguage?.translations.general.backToHomepageConfirm)
      if (leavePage) {
        dispatch(setSelectedPage('/'))
      } else {
        history.pushState(null, '', null)
      }
    });
  }, [])

  return <div className="h-full flex flex-col">
    <Header/>
    <Content/>
    {keyboardContext.opened && <Keyboard/>}
  </div>
}
